module.exports = __webpack_public_path__ + "img/icon-track-light-blue-horizontal.d365baa2.svg";